"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Icon_1 = require("../../Icon");
var Typography_1 = require("../../Typography");
var ButtonContent = function (_a) {
    var children = _a.children, leftIcon = _a.leftIcon, _b = _a.leftIconSize, leftIconSize = _b === void 0 ? 'lg' : _b, leftIconOutlined = _a.leftIconOutlined, rightIcon = _a.rightIcon, _c = _a.rightIconSize, rightIconSize = _c === void 0 ? 'lg' : _c, rightIconOutlined = _a.rightIconOutlined, _d = _a.labelSize, labelSize = _d === void 0 ? 'sm' : _d, labelClasses = _a.labelClasses;
    var size = labelSize === 'lg' ? 'lg' : 'base';
    var label = children && ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h6", size: size, className: (0, classnames_1.default)('squid-whitespace-nowrap', labelClasses) }, { children: children })));
    if (!leftIcon && !rightIcon) {
        return label;
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-items-center squid-justify-center squid-flex-row" }, { children: [leftIcon && ((0, jsx_runtime_1.jsx)("span", __assign({ className: label || rightIcon ? 'squid-mr-component-button-space' : undefined }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: leftIcon, size: leftIconSize, variant: leftIconOutlined ? 'outline' : 'solid' }) }))), label, rightIcon && ((0, jsx_runtime_1.jsx)("span", __assign({ className: label || leftIcon ? 'squid-ml-component-button-space' : undefined }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: rightIcon, size: rightIconSize, variant: rightIconOutlined ? 'outline' : 'solid' }) })))] })));
};
exports.default = ButtonContent;
